export const GEO_COORDS_API = "https://geocode.search.hereapi.com/v1/geocode";
export const GEO_COORDS_API_KEY = "I0m_T2MxqnXW_pNPXiqwWXHKxDZ7ZHwup7WIzcY63t0";
export const VUE_GOOGLEMAP_API_KEY = "AIzaSyAuqezeE757aRoz-etoFyDy09c8G_9CAao";
